import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Suppliers from "./pages/Suppliers";
import Materials from "./pages/Materials";
import InspectionTemplates from "./pages/InspectionTemplates";
import Schedules from "./pages/Schedules";
import SupplierSchedules from "./pages/SupplierSchedules";
import MaterialCategories from "./pages/MaterialCategories";
import GateEntry from "./pages/GateEntry";
import GRN from "./pages/GRN";
import Quality from "./pages/Quality";
import StockIn from "./pages/StockIn";
import OutwardScan from "./pages/OutwardScan";
import Stock from "./pages/Stock";
import MaterialHistory from "./pages/MaterialHistory";
import Users from "./pages/Users";
import Roles from "./pages/Roles";
import Settings from "./pages/Settings";
import AuditLog from "./pages/AuditLog";
import Alerts from "./pages/Alerts";
import PurchaseOrders from "./pages/PurchaseOrders";
import InventoryAdjustments from "./pages/InventoryAdjustments";
import DeliveryChallans from "./pages/DeliveryChallans";
import MaterialRequests from "./pages/MaterialRequests";
import AbnormalReport from "./pages/AbnormalReport";
import NGTrend from "./pages/NGTrend";
import FifoOverrides from "./pages/FifoOverrides";
import Reports from "./pages/Reports";
import DeletedRecords from "./pages/DeletedRecords";
import Approvals from "./pages/Approvals";
import AssetRegister from "./pages/AssetRegister";
import Visitors from "./pages/Visitors";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="suppliers" element={<Suppliers />} />
              <Route path="materials" element={<Materials />} />
              <Route path="materials/:id/history" element={<MaterialHistory />} />
              <Route path="templates" element={<InspectionTemplates />} />
              <Route path="schedules" element={<Schedules />} />
              <Route path="supplier-schedules" element={<SupplierSchedules />} />
              <Route path="material-categories" element={<MaterialCategories />} />
              <Route path="purchase-orders" element={<PurchaseOrders />} />
              <Route path="adjustments" element={<InventoryAdjustments />} />
              <Route path="challans" element={<DeliveryChallans />} />
              <Route path="material-requests" element={<MaterialRequests />} />
              <Route path="reports/abnormal" element={<AbnormalReport />} />
              <Route path="reports/ng-trend" element={<NGTrend />} />
              <Route path="fifo-overrides" element={<FifoOverrides />} />
              <Route path="reports" element={<Reports />} />
              <Route path="deleted-records" element={<DeletedRecords />} />
              <Route path="approvals" element={<Approvals />} />
              <Route path="edit-approvals" element={<Navigate to="/approvals" replace />} />
              <Route path="over-receipt-approvals" element={<Navigate to="/approvals" replace />} />
              <Route path="assets" element={<AssetRegister />} />
              <Route path="visitors" element={<Visitors />} />
              <Route path="gate-entry" element={<GateEntry />} />
              <Route path="grn" element={<GRN />} />
              <Route path="quality" element={<Quality />} />
              <Route path="stock-in/:grnId" element={<StockIn />} />
              <Route path="stock" element={<Stock />} />
              <Route path="users" element={<Users />} />
              <Route path="roles" element={<Roles />} />
              <Route path="settings" element={<Settings />} />
              <Route path="audit" element={<AuditLog />} />
              <Route path="alerts" element={<Alerts />} />
            </Route>
            <Route path="/outward" element={<ProtectedRoute><OutwardScan /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
